import { createAsyncThunk } from "@reduxjs/toolkit";

import logger from "Libs/logger";
import { environmentSelector } from "Reducers/environment";
import { DeploymentStrategyType } from "Reducers/environment/deployment";
import { AsyncThunkOptionType } from "Reducers/types";

import type { Activity } from "Api/activity/types";

export const deploy = createAsyncThunk<
  Activity,
  {
    organizationId: string;
    projectId: string;
    environmentId: string;
    deploymentStrategy?: DeploymentStrategyType;
  },
  AsyncThunkOptionType
>(
  "app/environment/actions/deploy",
  async (
    { organizationId, projectId, environmentId, deploymentStrategy },
    { getState, rejectWithValue, dispatch }
  ) => {
    try {
      const environment = environmentSelector(getState(), {
        organizationId,
        projectId,
        environmentId
      });

      if (!environment) {
        return rejectWithValue({ message: "Environment not found" });
      }
      const activityReducerModule = await import("Reducers/activity");
      const loadActivitySuccess = activityReducerModule.loadActivitySuccess;

      const deploy = await environment.deploy(deploymentStrategy);

      dispatch(
        /**
         * /resource/activity is an EventSource driven API that sends events when new activity happens on the project’s activity feed. You should be able to trigger this event by doing something like adding a project variable
         */
        loadActivitySuccess({
          activity: deploy
        })
      );

      return deploy;
    } catch (error: any) {
      if (error?.code / 100 === 4) {
        logger(error, {
          action: "deploy",
          meta: {
            organizationId,
            environmentId,
            projectId
          }
        });
      }
      return rejectWithValue(error);
    }
  }
);
